export default (routes, accountIDVStatus) => {
    const routeHasVisibility = ({ visibility }) =>
        (Array.isArray(visibility) && visibility.includes(accountIDVStatus)) || !visibility || !accountIDVStatus;

    return routes.filter((route) => routeHasVisibility(route));
};
